export default __webpack_public_path__ + "static/media/IMG-20160604-WA0019.93d64293.jpg";